import { render, staticRenderFns } from "./MultipleChoiceTextImageQuestionTextAnswer.vue?vue&type=template&id=b8f7a268"
import script from "./MultipleChoiceTextImageQuestionTextAnswer.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceTextImageQuestionTextAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports